import PropTypes from 'prop-types'
import { Redirect, Route, withRouter } from 'react-router-dom'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const loyaltyToken = localStorage.getItem('@loyalty:token')

  return (
    <Route
      {...rest}
      render={props =>
        !loyaltyToken ? <Redirect to="/faca-parte" /> : <Component {...props} />
      }
    />
  )
}

PrivateRoute.propTypes = {
  component: PropTypes.elementType
}

export default withRouter(PrivateRoute)
